module.exports = __webpack_public_path__ + "media/images/hrms/earth-circled-8d6caab1bbbb9df68c113f6a5ac5a327.png";